import { useCallback, useEffect, useState } from "react";
import { useScrollToTableTop } from "./useScrollToTableTop";

export const useFetchData = <TReq, TData>(
  service: any,
  request: TReq,
  query?: string
): {
  isLoading: boolean;
  data: TData[];
  fetchData: () => void;
  setData: React.Dispatch<React.SetStateAction<TData[]>>;
} => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { scrollToTop } = useScrollToTableTop();

  const [data, setData] = useState<TData[]>([]);

  const fetchData = useCallback(() => {
    setIsLoading(true);

    service
      .fetchAll(request)
      .then((res: TData[]) => {
        setData(res);
        query && scrollToTop(query);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [request, service, scrollToTop, query]);

  useEffect(() => fetchData(), [fetchData]);

  return { isLoading, data, fetchData, setData };
};
